import { render, staticRenderFns } from "./form-assistenza-preventivo.vue?vue&type=template&id=23ea8a22&"
import script from "./form-assistenza-preventivo.vue?vue&type=script&lang=js&"
export * from "./form-assistenza-preventivo.vue?vue&type=script&lang=js&"
import style0 from "./form-assistenza-preventivo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports